var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"id":"sozlesmeFrame","name":"sozlesmeFrame","srcdoc":_vm.sozlesmeMetni,"width":"100%","height":"500","frameborder":"no"}})
}
var staticRenderFns = []

export { render, staticRenderFns }